import { BREAKPOINTS } from '@jouzen/ecom-components/v3/consts/breakpoints';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';

import type { PhotoGridItemDimensions, PhotoGridItemProps } from './types';
import { getAspectRatioFromDimensions } from './utils/getAspectRatioFromDimensions';
import { getImgixParamsFromProps } from './utils/getImgixParamsFromProps';

export function PhotoGridItem({
  alt,
  className,
  dimensions,
  offset = { x: 0.5, y: 0.5 },
  src,
  trimColor = '',
  zoom = 1,
  id: _id,
}: Readonly<PhotoGridItemProps>) {
  const t = useTranslations();
  const aspectRatio: PhotoGridItemDimensions =
    getAspectRatioFromDimensions(dimensions);
  const queryString: string = getImgixParamsFromProps({
    aspectRatio,
    offset,
    trimColor,
    zoom,
  });
  const sizes = [
    // Compute large vw size based on provided dimensions which are based on 1440px
    `(min-width: ${BREAKPOINTS.large}px) ${Math.round((dimensions.width / 1440) * 100)}vw`,
    `(min-width: ${BREAKPOINTS.medium}px) 33vw`,
    '50vw',
  ];
  return (
    <div
      className={cx(
        'relative overflow-hidden rounded-lg lg:rounded-none lg:first:rounded-t-lg',
        className,
      )}
      data-cy="pop_lifestyle_photo_grid_item"
      style={{ aspectRatio: `${aspectRatio.width} / ${aspectRatio.height}` }}
    >
      <Image
        alt={t(alt)}
        className="size-full object-cover"
        data-cy="pop_lifestyle_photo_grid_image"
        height={dimensions.height}
        src={`${src}?${queryString}`}
        sizes={sizes.join(', ')}
        width={dimensions.width}
      />
    </div>
  );
}
